import PropTypes from "prop-types";
import React, { useState } from "react";

export default function TextInput({
  labelName = "Text Utils - Word | Charecter Counter, Remove extra spaces, lower <> upper case",
  defValue = "",
  mode = "light",
  handleAlert,
} = {}) {
  const [text, setText] = useState(defValue);

  const bgColor = mode === "light" ? "light" : "dark";
  const textColor = mode === "light" ? "dark" : "light";
  const btnDisabled = text.length === 0;

  // This function is called when the value of the textarea is changed.
  const handleOnChange = (event) => {
    setText(event.target.value);
  };

  const handleUpperBtnOnClick = () => {
    setText(text.trim().toUpperCase());
    // handleAlert({ message: "Converted to upper case.", type: "success" });
  };

  const handleLowerBtnOnClick = () => {
    setText(text.trim().toLowerCase());
  };

  const handleClearTextBtn = () => {
    setText("");
  };

  const handleReverseTextBtn = () => {
    setText(text.trim().split("").reverse().join(""));
  };

  const handleReverseWordsBtn = () => {
    setText(text.trim().split(" ").reverse().join(" "));
  };

  const handleCopyToClipboardBtn = () => {
    navigator.clipboard.writeText(text.trim());
    // handleAlert({ message: "Copied to clipboard.", type: "success" });
  };

  const handleRemoveSpacesBtn = () => {
    const cleanedText = text.trim().split(/[ ] +/);
    setText(cleanedText.join([" "]));
  };

  const hadleTitleCase = () => {
    const textArr = text.trim().split(" ");
    let newText = "";
    for (let i = 0; i < textArr.length; i++) {
      if (i > 0) {
        newText = newText + " ";
      }
      let word = textArr[i];
      word = word.trim();
      let wordLenght = word.length;
      if (wordLenght === 0) continue;
      if (wordLenght === 1) {
        word = word.toUpperCase();
        newText = newText + word;
      } else {
        word = word[0].toUpperCase() + word.slice(1).toLowerCase();
        newText = newText + word;
      }
    }
    setText(newText.trim());
  };

  const handleStaggeredCase = () => {
    const textArr = text.trim().split(" ");
    let newText = "";
    for (let i = 0; i < textArr.length; i++) {
      if (i > 0) {
        newText = newText + " ";
      }
      let word = textArr[i];
      word = word.trim();
      let wordLenght = word.length;
      if (wordLenght === 0) continue;
      if (wordLenght === 1) {
        word = word.toLowerCase();
        newText = newText + word;
      } else {
        word = word[0].toLowerCase() + word.slice(1).toUpperCase();
        newText = newText + word;
      }
    }
    setText(newText.trim());
  };

  const handleSentenceCase = () => {
    const fullStopArr = text.trim().split(".");
    let finalText = "";
    for (let i = 0; i < fullStopArr.length; i++) {
      let sentence = fullStopArr[i];
      sentence = sentence.trim();
      let sentenceLenght = sentence.length;
      if (sentenceLenght === 0) continue;
      let spaceArr = sentence.split(" ");
      let newSentence = "";
      for (let j = 0; j < spaceArr.length; j++) {
        let word = spaceArr[j];
        word = word.trim();
        let wordLenght = word.length;
        if (wordLenght === 0) continue;
        if (j === 0) {
          if (wordLenght === 1) {
            word = word.toUpperCase();
          } else {
            word = word[0].toUpperCase() + word.slice(1).toLowerCase();
          }
          newSentence = newSentence + word;
        } else {
          word = word.toLowerCase();
          newSentence = newSentence + word;
        }
        if (j !== spaceArr.length - 1) {
          newSentence = newSentence + " ";
        }
      }
      newSentence = newSentence + ".";
      finalText = finalText + newSentence;
      if (i !== fullStopArr.length - 1) {
        finalText = finalText + " ";
      }
    }
    setText(finalText.trim());
  };

  const handleCamelCase = () => {
    const textArr = text.trim().split(" ");
    let newText = "";
    for (let i = 0; i < textArr.length; i++) {
      let word = textArr[i];
      word = word.trim();
      let wordLenght = word.length;
      if (wordLenght === 0) continue;
      if (i <= 0) {
        if (wordLenght === 1) {
          word = word.toLowerCase();
          newText = newText + word;
        } else {
          word = word[0].toLowerCase() + word.slice(1).toLowerCase();
          newText = newText + word;
        }
      } else {
        if (wordLenght === 1) {
          word = word.toUpperCase();
          newText = newText + word;
        } else {
          word = word[0].toUpperCase() + word.slice(1).toLowerCase();
          newText = newText + word;
        }
      }
    }
    setText(newText.trim());
  };

  const handlePascalCase = () => {
    const textArr = text.trim().split(" ");
    let newText = "";
    for (let i = 0; i < textArr.length; i++) {
      let word = textArr[i];
      word = word.trim();
      let wordLenght = word.length;
      if (wordLenght === 0) continue;
      if (i <= 0) {
        if (wordLenght === 1) {
          word = word.toUpperCase();
          newText = newText + word;
        } else {
          word = word[0].toUpperCase() + word.slice(1).toLowerCase();
          newText = newText + word;
        }
      } else {
        if (wordLenght === 1) {
          word = word.toUpperCase();
          newText = newText + word;
        } else {
          word = word[0].toUpperCase() + word.slice(1).toLowerCase();
          newText = newText + word;
        }
      }
    }
    setText(newText.trim());
  };

  const getTextLength = (word) => {
    return word
      .trim()
      .split(" ")
      .filter((element) => {
        return element.length > 0;
      }).length;
  };

  const component = (
    <div className="m-4">
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h3 className={`my-3 text-${textColor}`}>{labelName}</h3>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <span className="badge bg-primary m-2">
            Word Count: {getTextLength(text)}
          </span>
          <span className="badge bg-secondary m-2">
            Character Count: {text.length}
          </span>
          <span className="badge bg-success m-2">
            Minutes to read: {0.08 * getTextLength(text)}
          </span>
        </div>
      </div>
      <textarea
        className={`form-control bg-${bgColor} text-${textColor}`}
        id="exampleFormControlTextarea1"
        rows="8"
        value={text}
        onChange={handleOnChange}
        placeholder="Enter your text here..."
      ></textarea>
      <div
        className="my-3"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "start",
          justifyContent: "flex-start",
          flexWrap: "wrap",
        }}
      >
        <button
          onClick={handleUpperBtnOnClick}
          disabled={btnDisabled}
          className="btn btn-primary mx-2 my-3"
        >
          Convert To Upper Case
        </button>
        <button
          onClick={handleLowerBtnOnClick}
          disabled={btnDisabled}
          className="btn btn-primary mx-2 my-3"
        >
          Convert To Lower Case
        </button>
        <button
          onClick={hadleTitleCase}
          disabled={btnDisabled}
          className="btn btn-primary mx-2 my-3"
        >
          Title Case
        </button>
        <button
          onClick={handleStaggeredCase}
          disabled={btnDisabled}
          className="btn btn-primary mx-2 my-3"
        >
          Staggered Case
        </button>
        <button
          onClick={handleSentenceCase}
          disabled={btnDisabled}
          className="btn btn-primary mx-2 my-3"
        >
          Sentence Case
        </button>
        <button
          onClick={handleCamelCase}
          disabled={btnDisabled}
          className="btn btn-primary mx-2 my-3"
        >
          Camel Case
        </button>
        <button
          onClick={handlePascalCase}
          disabled={btnDisabled}
          className="btn btn-primary mx-2 my-3"
        >
          Pascal Case
        </button>
        <button
          onClick={handleReverseTextBtn}
          disabled={btnDisabled}
          className="btn btn-primary mx-2 my-3"
        >
          Reverse Text
        </button>
        <button
          onClick={handleReverseWordsBtn}
          disabled={btnDisabled}
          className="btn btn-primary mx-2 my-3"
        >
          Reverse Words
        </button>
        <button
          onClick={handleRemoveSpacesBtn}
          disabled={btnDisabled}
          className="btn btn-primary mx-2 my-3"
        >
          Remove Extra spaces
        </button>
        <button
          onClick={handleCopyToClipboardBtn}
          disabled={btnDisabled}
          className="btn btn-primary mx-2 my-3"
        >
          Copy to Clipboard
        </button>
        <button
          onClick={handleClearTextBtn}
          disabled={btnDisabled}
          className="btn btn-primary mx-2 my-3"
        >
          Clear Text
        </button>
      </div>
      {/* <div
        className="my-3"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "start",
          justifyContent: "flex-start",
          flexWrap: "wrap",
        }}
      >
        <button
          // onClick={handleAlert({
          //   message: "Hello this is a test alert!",
          //   type: "success",
          // })}
          className="btn btn-outline-primary mx-2 my-3"
        >
          Test Alert
        </button>
      </div> */}
    </div>
  );
  return component;
}

TextInput.propTypes = {
  labelName: PropTypes.string.isRequired,
  defValue: PropTypes.string,
  mode: PropTypes.string,
  handleAlert: PropTypes.func,
};
